"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EncoreColors = void 0;
exports.EncoreColors = {
    PrimaryBlack: '#1C1C1E',
    TextBlack: '#020202',
    Primary: '#00BA5C',
    Primary2: '#003319',
    Primary3: '#132217',
    Primary30: 'rgba(0, 186, 92, 0.3)',
    Primary20: 'rgba(0, 186, 92, 0.2)',
    Primary150: 'rgba(0, 186, 92, 0.15)',
    GreenPressed50: 'rgba(0, 92, 45, 0.5)',
    GreenShadow: '#002412',
    GrayShadow: 'rgba(16, 24, 40, 0.05)',
    Gray: '#2C2C2E',
    Gray500: '#697586',
    Gray700: '#2C2E2C',
    MediumGray: '#979797',
    LightGray: '#8E8E93',
    LightGray50: '#E9E9E9',
    LightGray100: '#B1ADAD',
    LightGray200: '#D9D9D9',
    LightGray300: '#2C2C2E61',
    LightGray400: '#B2B2BB',
    TransparentGray: 'rgba(175, 175, 175, 0.80)',
    GreyText: '#AEAEB2',
    GreyBackground: '#3A3A3C',
    DarkBackground: '#222223',
    DarkGrey: '#888',
    GreyLine: '#636366',
    GreyBorder: '#888',
    White: '#fff',
    White070: 'rgba(255, 255, 255, 0.07)',
    White20: 'rgba(255, 255, 255, 0.20)',
    White30: 'rgba(255, 255, 255, 0.30)',
    White70: 'rgba(255, 255, 255, 0.70)',
    White90: 'rgba(255, 255, 255, 0.9)',
    Black: '#000',
    Black20: 'rgba(0, 0, 0, 0.2)',
    Black60: 'rgba(0, 0, 0, 0.6)',
    Black50: 'rgba(0, 0, 0, 0.5)',
    Success: '#8BBA00',
    Error200: '#220E0E',
    Error: '#E96161',
    Error500: '#FF3D3D',
    Error600: '#FF5050',
    ErrorBackground: 'rgba(255, 80, 80, 0.15)',
    Blue: '#1A89FF',
    Info100: '#FFBA09',
    Info200: '#FFBF00',
    Info300: '#FBBC05',
    Info500: '#FFEA00',
    DarkYellowBackground: '#795800',
    YellowBackground: '#E0A917',
    Pink: '#FF577F',
    Orange: '#FF884B',
    Yellow: '#FFCB3E',
    LightBlue: '#7FC7D9',
    Teal: '#45CFDD',
    LightGreen: '#A3FF53',
    LightPurple: '#FF9BF9',
    Transparent: 'rgba(0,0,0,0)',
};
